import styled from "styled-components";
import { Typography } from "antd";
import { PageTableWrapperStyled } from "styles/common.styles";

// Mirrors the People + AI landing / Jobs Library page shell: a fixed header on a
// card surface with only the table area scrolling (no full-body scroll).
export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const HeaderSection = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  flex-shrink: 0;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }
`;

export const TitleGroup = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  /* Zero the antd Title's default bottom margin so it aligns within the row. */
  .ant-typography {
    margin-bottom: 0;
  }
`;

export const ViewToggle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ViewByLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ViewByText = styled.span`
  font-size: 18px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.dark : theme.colors.textLight};
`;  

export const ClickableRowTableWrapper = styled(PageTableWrapperStyled)`
  .ant-table-row {
    cursor: pointer;
  }

  /* GroupTag's tag clips itself at 127px, but the surrounding cell doesn't — on a
     squeezed column that lets the tag bleed into the next column. Clip the cell
     too, so whichever is narrower wins. */
  .agent-library-group-cell {
    overflow: hidden;
  }
`;

export const SearchWrapper = styled.div`
  width: 400px;
  max-width: 100%;
  flex-shrink: 0;
`;

export const SearchIconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};

  .anticon {
    font-size: 14px;
    color: inherit;
  }
`;

export const TableSection = styled.div`
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  position: relative;
`;


export const DescriptionText = styled(Typography.Paragraph)`
  margin-bottom: 0 !important;
`;

export const GroupTag = styled.span`
  display: inline-block;
  cursor: pointer;
  .ant-tag {
    display: inline-block;
    max-width: 127px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
`;
